export default __webpack_public_path__ + "media/images/client-logos/stripe-607534b89d795813b996af99326cbfa6.png";